import ModuleDetails from 'app/PelatihanMandiriPage/pages/ModuleDetails'

export const ModulPageMobile = () => {
  return <ModuleDetails />
}
